import { RouteLocationNormalized } from 'vue-router';

export const possibleErrorMessagesAboutNotBeingAbleToLoadModules = [
  'error loading dynamically imported module',
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'Failed to load module script',
  'Unable to preload CSS for',
  'is not a valid JavaScript MIME type',
  'The network connection was lost.',
];

const isModuleLoadingError = (error: any) => {
  if (!error || !error.message) {
    return false;
  }

  return possibleErrorMessagesAboutNotBeingAbleToLoadModules.some((possibleModuleImportMsg) =>
    error.message.includes(possibleModuleImportMsg),
  );
};

export const moduleLoadingErrorHandler = (basePath: string) => {
  return (error: any, to: RouteLocationNormalized) => {
    console.error('Router error', error);
    console.warn('Failed to navigate to', to);
    /*
    After a new deployment, the user might have an old version of the app in their browser cache.
    They could try to go to a new page which is associated with another module and another js file,
    but the old file path does not exist anymore because a new version of the app
    has been deployed, and js modules have a new hash in their file name.

    We reload the page with the new route in this case.
     */
    if (isModuleLoadingError(error)) {
      const targetRouteFullPath = to.fullPath;
      let newPath = `${basePath}${targetRouteFullPath}`;
      /*
      The basePath ends with a slash, and the to.fullPath starts with a slash.
      We need to remove one of the slashes to avoid having two slashes in the URL.
       */
      if (basePath.endsWith('/') && to.fullPath.startsWith('/')) {
        newPath = `${basePath}${targetRouteFullPath.slice(1)}`;
      }

      window.location.href = newPath;
    }
  };
};
